import { useState, useEffect } from 'react';
import { offlineTaskQueue } from '@/lib/offlineQueue';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Update pending count
    const updatePendingCount = async () => {
      const count = await offlineTaskQueue.getCount();
      setPendingCount(count);
    };

    updatePendingCount();

    // Listen for sync completion (returns unsubscribe function)
    const unsubscribeSync = offlineTaskQueue.onSync(() => {
      updatePendingCount();
    });

    // Poll for count changes
    const interval = setInterval(updatePendingCount, 5000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(interval);
      unsubscribeSync();
    };
  }, []);

  const sync = async () => {
    const result = await offlineTaskQueue.sync();
    const count = await offlineTaskQueue.getCount();
    setPendingCount(count);
    return result;
  };

  return { isOnline, pendingCount, sync };
}
